module.exports = __webpack_public_path__ + "img/4.24c06f13.webp";